import { HubConnection, HubConnectionBuilder, IHttpConnectionOptions } from '@microsoft/signalr';
import { MessagePackHubProtocol } from '@microsoft/signalr-protocol-msgpack';

export class HubBuilder {
  private readonly _connection: HubConnection;

  constructor(url: string, options: IHttpConnectionOptions = {}, isBackendApiV2: boolean) {
    if (isBackendApiV2) {
      this._connection = new HubConnectionBuilder()
        .withUrl(
          url,
          options,
        )
        .withHubProtocol(new MessagePackHubProtocol())
        .build();
    }
    else {
      this._connection = new HubConnectionBuilder()
        .withUrl(
          url,
          options,
        )
        .build();
    }
  }

  public get connection() {
    return this._connection;
  }

  public connect = () => {
    return this.connection.start();
  };

  public stop = () => {
    return this.connection.stop();
  };
}
